import { useUserFeature } from "hooks/useUserFeature";
import { INotificationActivityList } from "models/UserSetting";

export const NOTIFICATIONS_ACTIVITY_ITEMS = (): INotificationActivityList[] => {
  const { isShipper, isCarrierSubscribed, isCarrierTrial } = useUserFeature();

  return [
    {
      label: "Load Match to Your Truck",
      value: "load_match_to_truck",
      hidden: false
    },
    {
      label: "Truck Match to Your Load",
      value: "load_match_to_load",
      hidden: isShipper || isCarrierSubscribed || isCarrierTrial
    },
    {
      label: "New Bid on Your Load",
      value: "new_bid_on_load",
      hidden: isCarrierSubscribed || isCarrierTrial
    },
    {
      label: "Bid Has Been Retracted",
      value: "bid_has_been_retracted",
      hidden: isCarrierSubscribed || isCarrierTrial
    },
    {
      label: "You Have Been Under-Bid",
      value: "you_have_been_under",
      hidden: isShipper
    },
    {
      label: "New Question on Your Post",
      value: "new_question_for_post",
      hidden: false
    },
    {
      label: "New Response on Your Question",
      value: "new_answer_to_question",
      hidden: false
    },
    {
      label: "Load Post Trip Status Updates",
      value: "load_post_trip_updates",
      hidden: isCarrierSubscribed || isCarrierTrial
    },
    {
      label: "Haul Pay Alerts",
      value: "haul_pay_alerts",
      hidden: isShipper
    },
    {
      label: "Assigned Load Alerts",
      value: "bid_has_been_awarded",
      hidden: !isCarrierSubscribed
    }
  ];
};
